export const initialState = (inputResponse: any, isEdit = false) => {
  //   if (isEdit) {
  //     let outputObject = {};
  //     for (const key in inputResponse) {
  //       outputObject = {
  //         ...outputObject,
  //         [key]: { value: inputResponse[key], error: "" },
  //       };
  //     }
  //     return outputObject;
  //   } else
  return {
    organizationId: { value: inputResponse._id ?? "", error: "" },
    companyname: { value: inputResponse.companyname ?? "", error: "" },
    brandname: { value: inputResponse.brandname ?? "", error: "" },
    country_id: { value: inputResponse.country_id ?? "", error: "" },
    currency: { value: inputResponse.currency ?? "", error: "" },
    country_code: { value: inputResponse.country_code ?? "", error: "" },
    time_zone: { value: inputResponse.time_zone ?? "", error: "" },
    state_id: { value: inputResponse.state_id ?? "", error: "" },
    city: { value: inputResponse.city ?? "", error: "" },
    address1: { value: inputResponse.address1 ?? "", error: "" },
    address2: { value: inputResponse.address2 ?? "", error: "" },
    zipcode: { value: inputResponse.zipcode ?? "", error: "" },
    website: { value: inputResponse.website ?? "", error: "" },
    imageUrl: { value: inputResponse.imageUrl ?? "Https//:", error: "" },
    company_type: {
      value: inputResponse.company_type ?? "Real Estate",
      error: "",
    },
  };
};

export const handleValidation = (rawInput: any) => {
  if (rawInput.organizationId.value === "") {
    rawInput.organizationId.error = "Please enter a valid organization ID";
  }
  if (rawInput.companyname.value === "") {
    rawInput.companyname.error = "Please enter a valid company name";
  }
  if (rawInput.brandname.value === "") {
    rawInput.brandname.error = "Please enter a valid brand name";
  }
  if (rawInput.country_id.value === "") {
    rawInput.country_id.error = "Please enter a valid country ID";
  }
  if (rawInput.currency.value === "") {
    rawInput.currency.error = "Please enter a valid default currency";
  }
  if (rawInput.country_code.value === "") {
    rawInput.country_code.error = "Please enter a valid default country code";
  }
  if (rawInput.time_zone.value === "") {
    rawInput.time_zone.error = "Please enter a valid default time zone";
  }
  if (rawInput.state_id.value === "") {
    rawInput.state_id.error = "Please enter a valid state ID";
  }
  if (rawInput.city.value === "") {
    rawInput.city.error = "Please enter a valid city";
  }
  if (rawInput.address1.value === "") {
    rawInput.address1.error = "Please enter a valid address1";
  }
  if (rawInput.address2.value === "") {
    rawInput.address2.error = "Please enter a valid address2";
  }
  if (rawInput.zipcode.value === "") {
    rawInput.zipcode.error = "Please enter a valid ZIP code";
  }
  if (rawInput.website.value === "") {
    rawInput.website.error = "Please enter a valid website URL";
  }
  return rawInput;
};

export const validateInput = (name: string, value: string) => {
  if (name === "organizationId") {
    if (!/^[a-zA-Z0-9]+$/.test(value) || value.length > 10) {
      return false;
    }
  }
  if (name === "companyname" || name === "brandname") {
    if (!/^[a-zA-Z0-9\s]+$/.test(value) || value.length > 30) {
      return false;
    }
  }
  if (name === "country_id" || name === "state_id") {
    if (!/^[a-zA-Z]+$/.test(value) || value.length > 2) {
      return false;
    }
  }
  if (name === "currency" || name === "country_code" || name === "time_zone") {
    if (!/^[a-zA-Z]+$/.test(value) || value.length > 3) {
      return false;
    }
  }
  if (name === "city") {
    if (!/^[a-zA-Z\s]+$/.test(value) || value.length > 30) {
      return false;
    }
  }
  if (name === "address1" || name === "address2") {
    if (!/^[a-zA-Z0-9\s.,-]+$/.test(value) || value.length > 100) {
      return false;
    }
  }
  if (name === "zipcode") {
    if (!/^[0-9]+$/.test(value) || value.length > 6) {
      return false;
    }
  }
  //   if (name === "website") {
  //     if (!/^https?:\/\/[\w.-]+\.[a-zA-Z]{2,}$/i.test(value) && value !== "") {
  //       return false;
  //     }
  //   }

  return true;
};

export const getFinalBodyStructure = (inputBody: any) => {
  let finalBody = {};
  for (const key in inputBody) {
    finalBody = { ...finalBody, [key]: inputBody[key].value };
  }
  const newObj: any = { ...finalBody };

  // newObj.organizationId = userId;

  ["_id"].forEach((key: any) => delete newObj[key]);

  return newObj;
};
